import React from 'react';
import {connect} from 'react-redux';
import {Dispatch} from '@Redux/type';
import {AppState} from '@Redux/store';

const BookEditComponent: React.FC<Props> = ({  }) => {
  return (
    <></>
  );
};

const mapStateToProps = (state: AppState) => ({
})

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BookEditComponent);

type Props = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
